<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-edit-partial :domain="domain" />

                <h1 class="page-block__title | u-font-weight-normal">{{ trans('domain.edit-nameservers') }}</h1>

                <div class="page-block">
                    <div class="page-block__item-wrapper">
                        <div
                            v-if="nameservergroup !== 'realhosting'"
                            class="alert alert--warning | u-margin-top-flush u-margin-bottom-narrow"
                        >
                            <small>
                                {{ trans('domain.nameservers.general-information', { domain: this.companyName }) }}
                            </small>
                        </div>

                        <form @submit.prevent="changeNameservers" class="u-full-width">
                            <div v-if="nameservergroup !== 'realhosting'">
                                <div class="field field--inline">
                                    <input
                                        v-model="form.nameserver_choice"
                                        class="field__input | u-margin-right-inline"
                                        id="nameserver-default"
                                        type="radio"
                                        value="nameserver_default"
                                    />
                                    <label class="field__label" for="cancel-end-date">
                                        {{
                                            trans('domain.nameservers.set-default-nameservers', {
                                                domain: this.companyName
                                            })
                                        }}
                                    </label>
                                </div>
                                <div class="field field--inline">
                                    <input
                                        v-model="form.nameserver_choice"
                                        class="field__input | u-margin-right-inline"
                                        id="nameserver-external"
                                        type="radio"
                                        value="nameserver_external"
                                    />
                                    <label class="field__label" for="cancel-immediately">
                                        {{ trans('domain.nameservers.set-external-nameservers') }}
                                    </label>
                                </div>
                            </div>
                            <div
                                v-if="
                                    form.nameserver_choice === 'nameserver_external' ||
                                        nameservergroup === 'realhosting'
                                "
                            >
                                <div
                                    v-if="nameservergroup === 'realhosting'"
                                    class="alert alert--warning | u-margin-top-flush u-margin-bottom-narrow"
                                >
                                    <small>
                                        {{
                                            trans('domain.nameservers.external-information', {
                                                domain: this.companyName
                                            })
                                        }}
                                    </small>
                                </div>
                                <text-input
                                    v-model="form.nameServers[0].name"
                                    :error="form.errors.first('nameServers.0.name')"
                                    :label="trans('domain.nameservers.labels.nameserver1')"
                                    :name="trans('domain.nameservers.labels.nameserver1')"
                                    class="u-full-width"
                                    required
                                />

                                <text-input
                                    v-model="form.nameServers[1].name"
                                    :error="form.errors.first('nameServers.1.name')"
                                    :label="trans('domain.nameservers.labels.nameserver2')"
                                    :name="trans('domain.nameservers.labels.nameserver2')"
                                    class="u-full-width"
                                    required
                                />

                                <text-input
                                    v-model="form.nameServers[2].name"
                                    :error="form.errors.first('nameServers.2.name')"
                                    :label="trans('domain.nameservers.labels.nameserver3')"
                                    :name="trans('domain.nameservers.labels.nameserver3')"
                                    class="u-full-width"
                                />

                                <text-input
                                    v-model="form.nameServers[3].name"
                                    :error="form.errors.first('nameServers.3.name')"
                                    :label="trans('domain.nameservers.labels.nameserver4')"
                                    :name="trans('domain.nameservers.labels.nameserver4')"
                                    class="u-full-width"
                                />

                                <text-input
                                    v-model="form.nameServers[4].name"
                                    :error="form.errors.first('nameServers.4.name')"
                                    :label="trans('domain.nameservers.labels.nameserver4')"
                                    :name="trans('domain.nameservers.labels.nameserver4')"
                                    class="u-full-width"
                                />

                                <text-input
                                    v-model="form.nameServers[5].name"
                                    :error="form.errors.first('nameServers.5.name')"
                                    :label="trans('domain.nameservers.labels.nameserver4')"
                                    :name="trans('domain.nameservers.labels.nameserver4')"
                                    class="u-full-width"
                                />

                                <text-input
                                    v-model="form.nameServers[6].name"
                                    :error="form.errors.first('nameServers.6.name')"
                                    :label="trans('domain.nameservers.labels.nameserver4')"
                                    :name="trans('domain.nameservers.labels.nameserver4')"
                                    class="u-full-width"
                                />

                                <text-input
                                    v-model="form.nameServers[7].name"
                                    :error="form.errors.first('nameServers.7.name')"
                                    :label="trans('domain.nameservers.labels.nameserver4')"
                                    :name="trans('domain.nameservers.labels.nameserver4')"
                                    class="u-full-width"
                                />
                            </div>

                            <div class="modal__nav">
                                <button class="btn btn--blue-record btn-ghost--dns" dusk="confirm-button" type="submit">
                                    {{ trans('action.set') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { apiMixin } from 'relapp-api';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { DomainOverview } from 'relapp-domain';
import { HeaderEditPartial, serviceMixin, servicesPageMixin, NameserverApi } from 'relapp-technical-management';
import { Way2Form } from 'relapp-way2forms';
import { EventBus } from 'relapp-event';
import { mapGetters } from 'vuex';

export default {
    components: {
        HeaderEditPartial,
        DomainOverview
    },
    mixins: [apiMixin, pageLoadingStatusMixin, serviceMixin, servicesPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'extension',
            form: new Way2Form({
                nameServers: [
                    {
                        name: null
                    },
                    {
                        name: null
                    },
                    {
                        name: null
                    },
                    {
                        name: null
                    },
                    {
                        name: null
                    },
                    {
                        name: null
                    },
                    {
                        name: null
                    },
                    {
                        name: null
                    }
                ],
                nameserver_choice: 'nameserver_default'
            })
        };
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.domain.title', { domain: this.domain })
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.fillForm();
        this.finishLoading();
        if (this.service) {
            NameserverApi.get(this.routeParams).then(this.fillForm);
        }
    },
    computed: {
        ...mapGetters({
            nameservers: 'nameservers/items',
            nameservergroup: 'nameservers/nameserverGroup'
        }),

        /**
         * Return the company name.
         *
         * @return {array}
         */
        companyName() {
            return process.env.VUE_APP_COMPANY_NAME;
        }
    },
    methods: {
        /**
         * Fill the form with the nameservers from the store.
         */
        fillForm() {
            let nameServers = Array(8).fill({ name: null });

            this.nameservers.forEach((nameserver, index) => {
                nameServers[index] = { name: nameserver.name };
            });

            this.form.populate({ nameServers });
        },
        /**
         * Confirm resetting nameservers.
         *
         * @return {function}
         */
        changeNameservers() {
            if (this.form.nameserver_choice === 'nameserver_external' || this.nameservergroup === 'realhosting') {
                return this.setExternalNameservers();
            }

            return this.confirmDefault();
        },
        /**
         * Confirm resetting nameservers.
         */
        confirmDefault() {
            this.startLoading();

            NameserverApi.reset(this.domain).then(() => {
                this.$router.push({ name: 'domainOverview', params: { domain: this.domain } });

                EventBus.$emit('notification', {
                    type: 'success',
                    message: trans('services.confirmation.nameservers.message')
                });
                this.finishLoading();
            });
        },
        /**
         * Call the endpoint to set external nameservers.
         */
        setExternalNameservers() {
            this.startLoading();
            NameserverApi.update(this.form.data(), this.routeParams)
                .then(() => {
                    this.$router.push({ name: 'domainOverview', params: { domain: this.domain } });

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('services.confirmation.nameservers.message')
                    });
                })
                .catch(error => {
                    this.showValidationErrors(error, this.form);
                })
                .then(this.finishLoading);
        }
    }
};
</script>
